import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentStructureValueType on StructureValueType {
    __typename
  }
`
// TODO:
export const TRANSFORMER = graphql.transformers.OUT.always(undefined)
// export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
//   graphql.schema.FragmentStructureValueTypeFragment,
//   ents.core.common.value.types.Structure,
//   '__typename'
// >('__typename', {
//   IntrinsicValueTypeWrapper: graphql.transformers.OUT.select(
//     'intrinsic',
//     INTRINSIC_VALUE_TYPE,
//   ),
//   StructureValueType: graphql.transformers.OUT.select(
//     'enum',
//     INTRINSIC_VALUE_TYPE,
//   ),
//   // StructureValueType: ,
// })
